
import React from 'react';
import './home.scss';

const Home = () => {
  return (
    <div className="home">
      <div className="home__content">
        <h1>Welcome to Openlexia</h1>
        <div className="info-card">
          <h2>Proof of Concept</h2>
          <p>
            This page is a proof of concept to give an overview of the application. 
            Please note that it's currently in development, has minimal styling, 
            and your work may be overwritten by other users.
            Feel free to explore and experiment with the application.
          </p>
          
          <h3>Available Features:</h3>
          <ul>
            <li>
              <strong>Editing Lectures:</strong> Navigate to "My Drafts", create or edit a draft, 
              then use "Save Draft" + "Publish" to see your changes in the lecture view
            </li>
            <li>
              <strong>Markup Language:</strong> Use our basic markup system for content formatting - 
              see the <a href="/doc/editor/markup">Markup Documentation</a> for details
            </li>
            <li>
              <strong>Audio Support:</strong> Upload audio files to enhance your lectures
            </li>
            <li>
              <strong>Demo Content:</strong> Check out our demo lecture in{' '}
              <a href="https://openlexia.org/lecture?cours=learnfrench&pageId=M6DKHFL2KUK">
                Dire bonjour
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;
